package de.oevbs.kunde.kundenportal2.model.services.registration

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class RegistrationClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Erstellt oder aktualisiert eine Registrierung. Wenn ein Token im Modell ist, wird die entsprechende laufende
     * Registrierung aus der Cosmos-Datenbank geholt. Sonst wird ein leeres Objekt erstellt und in der DB angelegt.
     * Das neu erstellte oder aktualisierte Objekt wird zurückgegeben.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun createOrUpdate(maiLData: RegistrationMail): ClientResponse<Unit> =
        post("/registration/register", maiLData)


    /**
     * Der User hat seinen gewünschten Username und Passwort eingegeben und die Daten werden nun als User in der
     * Kundenportal-CosmosDB gespeichert. Das zuvor erstellte Registration-Objekt wird aus der Datenbank gelöscht.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun createUser(userData: RegistrationUser): ClientResponse<Unit> =
        post("/registration/createuser", userData)
}